import {
    RESERVATION_SESSION_START,
    RESERVATION_SESSION_STOP,
} from 'store/actions/types';

export const reservationSessionStart = (payload) => {
    return {
        type: RESERVATION_SESSION_START,
        payload: payload,
    };
};

export const reservationSessionStop = (payload) => {
    return {
        type: RESERVATION_SESSION_STOP,
        payload: payload,
    };
};

export const reservationSessionOpenBarrier = (payload) => {
    return {
        type: 'RESERVATION_SESSION_OPEN_BARRIER',
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reservations/session/reservationSessions.js